package br.com.texeratx.boardgametimeapp.ui.components.dashboard

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.ui.components.PlayerAvatar

@Composable
fun DashboardHeroHeader(
    clanName: String,
    clanImageUrl: String?,
    onClanClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .clickable { onClanClick() }
            .padding(vertical = 6.dp),
        horizontalArrangement = Arrangement.Start
    ) {
        PlayerAvatar(
            imageUrl = clanImageUrl,
            contentDescription = clanName,
            size = 34.dp
        )
        Spacer(Modifier.width(10.dp))
        Column {
            Text(
                text = clanName,
                style = MaterialTheme.typography.headlineSmall.copy(fontWeight = FontWeight.ExtraBold),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}
